import axios from "axios";
import { toast } from "react-toastify";
import config from "../config";

// default
axios.defaults.baseURL = config.API_URL;

// content type
axios.defaults.headers.post["Content-Type"] = "application/json";

// A 401 here means the stored token is missing/rejected by the server (not
// necessarily "wrong password" — /auth/login itself is excluded below since
// that route also 401s on bad credentials, which Login.js already handles
// with its own toast). Previously this just swapped in an "Invalid
// credentials" message with no session clear/redirect, so an admin with a
// stale token saw that message scattered across whatever page they were on
// with no path back to a clean login. Mirrors the store app's equivalent fix
// (susistore/src/request.js).
let sessionExpiredHandled = false;

function forceReLogin() {
  if (sessionExpiredHandled) {
    return;
  }
  sessionExpiredHandled = true;
  localStorage.removeItem("token");
  localStorage.removeItem("role");
  localStorage.removeItem("storeId");
  localStorage.removeItem("storeName");
  localStorage.removeItem("authUser");
  localStorage.removeItem("state");
  toast.error("Your session has expired. Please log in again.");
  window.location.href = "/login";
}

// intercepting to capture errors
axios.interceptors.response.use(
  function (response) {
    return response.data ? response.data : response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    const status = error.response ? error.response.status : null;
    const url = error.config?.url || "";
    let message;

    // Extract server-provided error message if available
    const serverMessage = error.response?.data?.error?.message || error.response?.data?.message;

    if (serverMessage) {
      message = serverMessage;
    } else {
      switch (status) {
        case 500:
          message = "Internal Server Error";
          break;
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the data you are looking for could not be found";
          break;
        default:
          message = error.message || error;
      }
    }

    if (status === 401 && !url.includes("/auth/login")) {
      forceReLogin();
    }

    return Promise.reject(message);
  }
);

/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token) => {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};

class APIClient {
  /**
   * Fetches data from given url
   */
  get = (url, params) => {
    return axios.get(url, params);
  };

  /**
   * post given data to url
   */
  create = (url, data) => {
    return axios.post(url, data);
  };

  /**
   * Updates data
   */
  update = (url, data) => {
    return axios.put(url, data);
  };

  /**
   * Delete
   */
  delete = (url, config) => {
    return axios.delete(url, { ...config });
  };
}

const getLoggedinUser = () => {
  const user = localStorage.getItem("authUser");
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

export { APIClient, setAuthorization, getLoggedinUser };
